import { isDefined } from 'src/utils/TypeCheckers';
import { JWTTokens, Session } from './types';
import { VX_CACHE_PREFIX } from 'src/providers/cache/inMemoryCache';

const LOCAL_STORE_KEY = 'jwt-session';
const ENROLMENT_SESSION_KEY = 'mfa:enrolment-session';
export const AUTH_REASON_KEY: string = 'auth:reason';

interface EnrolmentSession {
  accessToken?: string;
}

class GuslStorage {
  public clearSession = (): void => {
    const otherStoredKeys: string[] = [
      'shouldQueryParamsBeUpdated',
      'sideNavOpen',
      'appMode',
      'siemType',
      'orgId',
    ];

    localStorage.removeItem(LOCAL_STORE_KEY);
    sessionStorage.removeItem(ENROLMENT_SESSION_KEY);
    sessionStorage.removeItem('homePage');
    sessionStorage.removeItem('tenantId');
    for (const key in sessionStorage) {
      if (key.startsWith(VX_CACHE_PREFIX)) {
        sessionStorage.removeItem(key);
      }
    }
    for (const key in sessionStorage) {
      if (otherStoredKeys.includes(key)) {
        sessionStorage.removeItem(key);
      }
    }
  };
  public getPassRequiredSession = (): JWTTokens | undefined => {
    const tokensStr = localStorage.getItem(LOCAL_STORE_KEY);
    return tokensStr ? (JSON.parse(tokensStr) as JWTTokens) : undefined;
  };
  public setPassRequiredSession = (tokens: JWTTokens) => {
    localStorage.setItem(LOCAL_STORE_KEY, JSON.stringify(tokens));
    this.getJwtSession();
  };
  public getJwtSession = (): JWTTokens | undefined => {
    const tokensStr = localStorage.getItem(LOCAL_STORE_KEY);
    return tokensStr ? (JSON.parse(tokensStr) as JWTTokens) : undefined;
  };

  public setJwtSession = (tokens: JWTTokens) => {
    localStorage.setItem(LOCAL_STORE_KEY, JSON.stringify(tokens));
    this.getJwtSession();
  };

  public isJwt = (): boolean => {
    return isDefined(localStorage.getItem(LOCAL_STORE_KEY));
  };

  public setEnrolmentSession = (session: EnrolmentSession): void => {
    sessionStorage.setItem(ENROLMENT_SESSION_KEY, JSON.stringify(session));
  };

  public getEnrolmentSession = (): EnrolmentSession | null => {
    const raw = sessionStorage.getItem(ENROLMENT_SESSION_KEY);
    return raw ? (JSON.parse(raw) as EnrolmentSession) : null;
  };

  public clearEnrolmentSession = (): void => {
    sessionStorage.removeItem(ENROLMENT_SESSION_KEY);
  };

  getSession(): Promise<Session> {
    return new Promise<Session>((resolve) => {
      resolve({
        jwtTokens: guslStorage.getJwtSession(),
      });
    });
  }

  public hasSession = (): boolean => {
    return guslStorage.isJwt();
  };
}

const guslStorage = new GuslStorage();

export { guslStorage };

export default GuslStorage;
